<template>
  <div :class="$style.root">
    <template
      v-for="(entry, index) in data?.data"
      :key="index"
    >
      <PagesProjectsListThumbnailComponent
        :data="entry"
        :data-first-of-type="index === 0 ? '' : null"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
const i18nIso = 'nl-NL' //baseI18nGetDefaultIso()

const queryParams = computed(() => {
  return { locale: i18nIso }
})

const { data, error, pending } = await useAsyncData(() =>
  fetchQueryPath( queryProjectEntriesThumbnail(queryParams.value) )
)
</script>

<style module>
.root {
  composes: container from global;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--unit--default);
}

.item {
  padding: 0 var(--unit--default);
}
</style>
